<template>
  <div style="height: 100%;position: relative">
    <!--    头部导航栏-->
    <router-view name="top"></router-view>
    <!--    页面主体-->
    <router-view style="height: 100%;"></router-view>
    <router-view name="bottom" style="position: fixed;bottom: 0"></router-view>
  </div>
</template>

<script>
    import homeShow from './Home/homeShow'

    export default {
        components: {
            homeShow,
        }
    }
</script>

<style scoped>
  /*.el-carousel__item h3 {*/
  /*  color: #475669;*/
  /*  font-size: 18px;*/
  /*  opacity: 0.75;*/
  /*  line-height: 300px;*/
  /*  margin: 0;*/
  /*}*/

  /*.el-carousel__item:nth-child(2n) {*/
  /*  background-color: #99a9bf;*/
  /*}*/

  /*.el-carousel__item:nth-child(2n+1) {*/
  /*  background-color: #d3dce6;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/pages/homePage.vue